<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择行项"
      width="1200px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrderDetails/purchaseOrderDetail"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="primary" @click="add()">新增</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购单号：">
            <el-input v-model.trim="filter.purchaseOrderNo" type="textarea" placeholder="请输入采购单号" clearable/>
          </vm-search>
          <vm-search label="物料编号：">
            <el-input v-model.trim="filter.partNo" placeholder="请输入物料编号" clearable/>
          </vm-search>
          <vm-search label="出厂编号：">
            <el-input v-model.trim="filter.pcorderNo" type="textarea" placeholder="请输入出厂编号" clearable/>
          </vm-search>
          <vm-search label="直发标识">
            <el-select v-model.trim="filter.straightMark" placeholder="请选择">
              <el-option label="全部" :value="'-1'"/>
              <el-option label="直发" :value="'Z001'"/>
              <el-option label="非直发" :value="'1000'"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="supplierName" align="left" label="供应商" min-width="180" show-overflow-tooltip/>
      <el-table-column prop="rowNum" align="center" label="行号" width="80"/>
      <el-table-column prop="pCorderNo" align="center" label="出厂编号" width="120"/>
      <el-table-column prop="straightMark" align="center" label="直发标识" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.straightMark === '1000'">非直发</span>
          <span v-if="scope.row.straightMark === 'Z001'">直发</span>
        </template>
      </el-table-column>
      <el-table-column prop="partNo" align="center" label="物料编号" width="120" show-overflow-tooltip/>
      <el-table-column prop="partNameSpec" align="left" label="物料描述" min-width="150" show-overflow-tooltip/>
      <el-table-column prop="evaluate" align="center" label="采购单号" width="100" show-overflow-tooltip/>
      <el-table-column prop="responseDeliveryTime" align="center" label="交货期" width="90">
        <template slot-scope="scope">
          <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="剩余送货数量" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.qty - scope.row.hasInStorageQty}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="location" label="仓位" width="80"/>
      <!--      <el-table-column label="操作" align="center" width="80px" prop="action">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "PurchaseSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          purchaseOrderNo: "",
          supplierName: "",
          partNo: "",
          buyUserName: "",
          location: "",
          receiveStatus: 5,
          production: -1,
          isFinished: 1,
          straightMark: "-1",
          requireDeliveryDateBegin: "",
          requireDeliveryDateEnd: "",
          responseDeliveryTimeBegin: "",
          responseDeliveryTimeEnd: "",
          ahead: false,
          overdue: false,
          relatedCompany: true,
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      // // 选择
      // onSelect(row) {
      //   this.$emit("select", row);
      //   this.dialogVisible = false;
      // },
      select(selection) {
        this.selection = selection;
        // this.buyOrderNoList = [];
        // this.$emit("selectAll", this.selection);
        // this.dialogVisible = false;
      },
      add() {
        if(this.selection) {
          this.$emit("select", this.selection);
          this.dialogVisible = false;
        }else {
          this.$message.error("请选择需要添加的行项！");
        }
        
      },
    },
  };
</script>